/* import __COLOCATED_TEMPLATE__ from './name-cell-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();